import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LinkButton } from '@backstage/core-components';

type BackButtonProps = {
  to: string;
};

export const BackButton = ({ to }: BackButtonProps) => {
  return (
    <Box sx={{ position: 'relative', top: '10px', left: '27px' }}>
      <LinkButton to={to}>
        <Button
          variant="text"
          startIcon={<ArrowBackIcon />}
          sx={{
            color: 'color.secondary',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        />
      </LinkButton>
    </Box>
  );
};
